<div class="container container-shadow">
  <div class="row">
    <div class="col pb-5">
      <h4 class="mt-4">Payment Obligations</h4>
      <hr />
      <div class="my-5 py-5 text-center" *ngIf="loading">
        <i class="fas fa-fw fa-spinner fa-pulse fa-5x"></i>
      </div>
      <div *ngIf="!loading">
        <div class="row">
          <div class="col-sm-2 col-md-3"></div>
          <div class="col-sm-8 col-md-6">
            <div class="mb-3" *ngIf="obligations.length > 0">
              <button type="button" (click)="preparePayment()" [disabled]="preparingPayment" class="btn btn-primary btn-block">
                {{ preparingPayment ? 'Preparing Payment' : 'Pay Selected Obligations' }}<span *ngIf="preparingPayment"><i class="fas fa-pulse fa-fw fa-spinner"></i></span>
              </button>
            </div>
            <table class="table table-striped table-sm">
              <thead class="thead-dark">
                <th>
                  <div class="custom-control custom-checkbox mb-0" (click)="allSelect = !allSelect; allSelectToggle()">
                    <input type="checkbox" class="custom-control-input" [checked]="allSelect" [(ngModel)]="allSelect" />
                    <label class="custom-control-label"></label>
                  </div>
                </th>
                <th>Chart Of Account</th>
                <th>Outstanding</th>
              </thead>
              <tbody>
                <tr *ngFor="let obligation of obligations">
                  <td>
                    <div class="custom-control custom-checkbox mb-0" (click)="obligation.selected = !obligation.selected">
                      <input type="checkbox" class="custom-control-input" [checked]="obligation.selected" [(ngModel)]="obligation.selected" />
                      <label class="custom-control-label"></label>
                    </div>
                  </td>
                  <td>
                    {{ obligation.chart_of_account_name }}
                    <div *ngIf="obligation.payment_obligations && obligation.payment_obligations.length > 0">
                      <table class="table table-sm">
                        <tbody>
                          <tr *ngFor="let paymentObligation of obligation.payment_obligations">
                            <td>
                              <div class="custom-control custom-checkbox mb-0" (click)="paymentObligation.selected = !paymentObligation.selected">
                                <input type="checkbox" class="custom-control-input" [checked]="paymentObligation.selected" [(ngModel)]="paymentObligation.selected" />
                                <label class="custom-control-label"></label>
                              </div>
                            </td>
                            <td>{{ paymentObligation.created_at }}</td>
                            <td>{{ paymentObligation.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
                            <td>{{ paymentObligation.description }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                  <td>{{ obligation.outstanding | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
                </tr>
              </tbody>
            </table>
            <div class="mt-3" *ngIf="obligations.length > 0">
              <button type="button" (click)="preparePayment()" [disabled]="preparingPayment" class="btn btn-primary btn-block">
                {{ preparingPayment ? 'Preparing Payment' : 'Pay Selected Obligations' }}<span *ngIf="preparingPayment"><i class="fas fa-pulse fa-fw fa-spinner"></i></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #paymentModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Pay Payment Obligations</h4>
    <button type="button" class="close" [disabled]="creatingPayment" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <span class="text-muted">Based on the obligations selected, these are the disbursments grouped by contact that will be created. You may enter the actual amounts to pay in the boxes below.</span>
    <table *ngFor="let paymentCheck of paymentChecks" class="table table-sm">
      <thead>
        <tr class="thead-dark">
          <th colspan="2">
            {{ paymentCheck.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let chart_of_account of paymentCheck.data.chart_of_accounts">
          <td>
            {{ chart_of_account.name }}
          </td>
          <td style="width: 175px">
            <input style="width: 175px" type="number" class="text-right form-control form-control-sm" [(ngModel)]="chart_of_account.amount" (change)="calculateTotal()" />
          </td>
        </tr>
        <tr>
          <td class="text-right table-primary">
            <strong>Total</strong>
          </td>
          <td class="text-right pr-3 table-primary" style="width: 175px">
            {{ paymentCheck.total | currency: 'USD':'symbol-narrow':'1.2-2' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer text-center justify-content-center">
    <div class="text-center">
      <button [disabled]="creatingPayment" (click)="createPayment()" type="button" class="btn btn-primary">
        {{ creatingPayment ? 'Paying' : 'Pay' }}
        <span *ngIf="creatingPayment">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
      </button>
      &nbsp;
      <button [disabled]="creatingPayment" (click)="d('close')" type="button" class="btn btn-outline-secondary">Cancel</button>
    </div>
  </div>
</ng-template>
